<template>
    <div
        v-if="choices"
        :class="{
            'choices': true,
            'choices--single': !isMultipleChoice,
            'choices--multiple': isMultipleChoice,
            'choices--disabled': evaluating || disabled,
            'interaction': true,
        }"
    >
        <div
            v-for="(choice, index) in shuffledChoices"
            @click="(event) => handleChoiceClick(event, index)"
            :key="`choices-choice-${index}`"
            :class="{
                'choices__choice': true,
                'choices__choice--selected': choice.selected,
            }"
        >
            <span class="choices__choice-element"></span>
            <span class="choices__choice-text" v-html="choice.text" />
        </div>

        <interaction-evaluator
            v-if="!evaluatesExternal"
            :evaluating="evaluating"
            :feedback="feedback"
            :evaluation="evaluation"
            @evaluate="evaluate"
            @retry="reset"
            @solve="solve"
        />
    </div>
</template>

<script>
import shuffle from '@/common/utility/shuffleArray';
import ButtonElement from '@/components/elements/ButtonElement.vue';
import InteractionEvaluator from '@/components/elements/quiz/InteractionEvaluator.vue';

export default {
    name: 'ChoiceElement',
    components: {
        ButtonElement,
        InteractionEvaluator,
    },
    props: {
        choices: Array,
        feedback: Object,
        evaluatesExternal: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        settings: {
            type: Object,
            default: () => {
                return {
                    forceMultipleChoice: false
                }
            }
        },
    },
    data() {
        return {
            evaluating: false,
            shuffledChoices: [],
            evaluation: {
                correct: 0,
                incorrect: 0,
                passed: false,
            },
        }
    },
    computed: {
        isMultipleChoice() {
            return this.settings.forceMultipleChoice || this.choices.filter(c => c.correct).length > 1
        },
        getEvaluatedFeedback() {

            if (!this.feedback) { return null; }

            const positiveFeedback = this.feedback.positive || null;
            const negativeFeedback = this.feedback.negativerFeedback || null;

            return this.evaluating && this.evaluation.passed == true ? positiveFeedback : negativeFeedback;
        }
    },
    created() {
        this.reset();
    },
    methods: {
        initializeChoices() {
            this.shuffledChoices = JSON.parse(JSON.stringify(this.choices));
            this.shuffledChoices = shuffle(this.shuffledChoices);
            this.shuffledChoices.forEach((choice) => {
                choice.selected = false;
            });
        },
        handleChoiceClick(event, choiceIndex) {

            if (this.evaluating || this.disabled) { return; }

            const currentChoice = this.shuffledChoices[choiceIndex];

            if (!this.isMultipleChoice) {

                this.shuffledChoices.forEach((choice) => {
                    choice.selected = false;
                });

                this.$set(this.shuffledChoices, choiceIndex, { ...currentChoice, selected: true });

            } else {
                this.$set(this.shuffledChoices, choiceIndex, { ...currentChoice, selected: !currentChoice.selected });
            }
        },
        evaluate() {

            if (this.evaluating || this.disabled) { return; }

            const result = {
                correct: 0,
                incorrect: 0
            };

            this.shuffledChoices.forEach((choice) => {
                if (choice.correct == choice.selected) {
                    result.correct++;
                } else {
                    result.incorrect++;
                }
            });

            this.evaluation = Object.assign({}, this.evaluation, {
                correct: result.correct,
                incorrect: result.incorrect,
                passed: result.incorrect == 0,
            });

            this.evaluating = true;

            return this.evaluation;
        },
        reset() {
            this.evaluation = Object.assign({}, this.evaluation, {
                correct: 0,
                incorrect: 0,
                passed: false,
            });

            this.evaluating = false;

            this.initializeChoices();
        },
        solve() {
            this.shuffledChoices.forEach((choice) => {
                if (choice.correct) {
                    choice.selected = true;
                } else {
                    choice.selected = false;
                }
            });
        }
    }
}
</script>
